export var TreatmentsManager = {
  currentTargetId: null,
  gTable: null,
  domainId: null,
  init: function(domain_id) {
    TreatmentsManager.domainId = domain_id;
    TreatmentsManager.createButtonListeners();
    //TreatmentsManager.resetTreatment();
    TreatmentsManager.initTreatmentsTable();

    document.addEventListener("treatments_updated", (e) => TreatmentsManager.renderExistingTreatments(e.detail.data) );
    TreatmentsManager.reloadTreatments();
    
  },
  initTreatmentsTable: async function(callback) {
    TreatmentsManager.gTable = $('table#call_treatments_table').DataTable({
      dom: 'lftip',
      "lengthMenu": [[10, 25, 50, 100, -1],[10, 25, 50, 100, "All"]],
      columns: [
        { data : "description", "visible" : true, "searchable":true, "orderable":true},
        { data : "type", "visible" : true, "searchable":true, "orderable":true, "className": 'text-center',
          render: function ( data, type, row ) {
            return data == 'TREATMENT' ? 'Call Treatment' : data == 'CHAT' ? 'Chat' : data == 'SMS' ? data : ''
                }},
        { data : "in_use", "visible" : true, "searchable":true, "orderable":true, "className": 'text-center',
          render: function ( data, type, row ) {
                    return ( type === 'display') ? '<span class="fa '+(data > 0 ? "fa-check":"fa-times")+'"></span>' : data > 0
                }},
        { "visible" : true, "searchable":false, "orderable":false, "className": 'dt-center',
          render: function ( data, type, row ) {
                    return `<a class="edit" data-id='${row.id}' data-type='${row.type}'><i class="fa fa-pencil"></i></a>${row.in_use == 0 ? `<a class='delete' data-id='${row.id}' data-name='${row.description}' data-type='${row.type}'><i class='fa fa-trash-o'></i></a>`:``}`;
                }
        }
        ],
        "order": [[ 0, "asc" ]]
    });
  },
  /*
  Reloads the treatment list. An event is fired with the data so it can be updated anywhere it is used (e.g. dropdowns in campaigns tab)
  */
  reloadTreatments: async function(callback) {
    let res = await fetch(`/admin/domains/${TreatmentsManager.domainId}/treatments`);
    let data = await res.json();

    var event = new CustomEvent("treatments_updated", {
      detail:{
        data: data
      }
    });
    document.dispatchEvent(event);
    if(callback !== undefined) {
      callback();
    }
  },
  renderExistingTreatments: function(data) {
    TreatmentsManager.gTable.clear();
    TreatmentsManager.gTable.rows.add(data);
    TreatmentsManager.gTable.draw();
  },
  createButtonListeners: function() {
    $("#ct_create_treatment").on("click", function(e) {
      e.preventDefault();
      TreatmentsManager.currentTargetId = null;
      $("#call_treatment_path").show();
      $("#call_treatments_list").hide();
      $("#call_treatment_path span.title").text("Create")
    });

    $("#ct_edit_treatment").on("click", function(e) {
      e.preventDefault();
      let id = 21;
      TreatmentsManager.currentTargetId = null;
      $("#call_treatments_list").hide();
      document.querySelector('#text_treatment_btn').click();
      $("#call_treatment_path span.title").text("Edit")
      $("#call_treatment_path").show();
      document.querySelector("text-treatment").loadCallTreatment(id);
    });

    $("#call_treatments_list").on("click", "a.delete", async function(e){
      e.preventDefault();
      let id = $(this).data("id");
      let name = $(this).data("name");
      let type = $(this).data("type");
      const endPoint = (type.toLowerCase() == 'treatment') ? 'call_treatments' : 'message_treatments';

      if(confirm(`Do you want to delete ${name}?`)) {
        panel_refresh($('#call_treatments_list'));
        let res = await fetch(`/admin/domains/${TreatmentsManager.domainId}/${endPoint}/`+id, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
          method: 'DELETE'
        });
        TreatmentsManager.reloadTreatments(() => panel_refresh($('#call_treatments_list')));
      }
    });

    $("#call_treatments_list").on("click", "a.edit", async function(e){
      e.preventDefault();
      let id = $(this).data("id");
      let type = $(this).data("type");
      $("#call_treatments_list").hide();
      $("#call_treatment_path span.title").text("Edit")
      $("#call_treatment_path").show();
      if(document.querySelector("pbx-call-treatment")){
        document.querySelector("pbx-call-treatment").loadCallTreatment(id);
      } else {
        document.querySelector("create-treatment").loadTreatment(id, type);
      }
    });

  }
}